import { jsx as a } from "react/jsx-runtime";
import { clsx as i } from "clsx";
import p from "./Table.module.css.js";
const c = ({ children: l, width: e, colSpan: t, align: s, className: m, ref: o, ...r }) => /* @__PURE__ */ a(
  "td",
  {
    ref: o,
    colSpan: t,
    style: { width: e, textAlign: s },
    className: i([p.cell, m]),
    ...r,
    children: l
  }
);
c.displayName = "TableCell";
export {
  c as TableCell
};
//# sourceMappingURL=TableCell.js.map
